import { render, staticRenderFns } from "./SwapModal.vue?vue&type=template&id=d6743ca4"
import script from "./SwapModal.vue?vue&type=script&lang=ts"
export * from "./SwapModal.vue?vue&type=script&lang=ts"
import style0 from "./SwapModal.vue?vue&type=style&index=0&id=d6743ca4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports